// Utility to generate inline SVG placeholder images
export const createPlaceholderSVG = (
  width = 300,
  height = 300,
  text = "No Image"
) => {
  const fontSize = Math.max(8, Math.min(width, height) / 20);

  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 ${width} ${height}'%3E%3Crect width='${width}' height='${height}' fill='%23f3f4f6'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial, sans-serif' font-size='${fontSize}' fill='%236b7280'%3E${encodeURIComponent(
    text
  )}%3C/text%3E%3C/svg%3E`;
};

export const PLACEHOLDER_IMAGES = {
  small: createPlaceholderSVG(100, 100),
  medium: createPlaceholderSVG(300, 300),
  large: createPlaceholderSVG(500, 500),
  cart: createPlaceholderSVG(200, 200),
  thumbnail: createPlaceholderSVG(64, 64),
  admin: createPlaceholderSVG(100, 100),
};
